import gql from 'graphql-tag';

export const PAGE_FRAGMENT = gql`
    fragment Page on Page {
        id
        createdAt
        updatedAt
        name
        slug
        storeSite {
            id
            name
            identifier
        }
        type
        product {
            id
            name
            slug
        }
        collection {
            id
            name
            slug
        }
        webPresenceConfig {
            useBuiltInSeo
            title
            description
            sitemapIndexing
            openGraphTitleSameAsSeoTitle
            openGraphDescriptionSameAsSeoDescription
            openGraphTitle
            openGraphDescription
            metaAssetId
            h1Source
            h1Text
            h1StyleMode
            h1FontSize
            h1MobileFontSize
            h1Color
            h1Alignment
        }
        navigationMenu {
            targetType
            label
            pageSlug
            pageSection
            builtInPage
            customSlug
            websiteUrl
            targetProductId
            targetProductSlug
            targetCollectionId
            targetCollectionSlug
        }
        pageComponents {
            type
            sectionId
            titleMode
            title {
                format
                i18n
            }
            subtitle {
                format
                i18n
            }
            titleUnderline
            layoutOption
            marketingBannerData
            keyPointListData
            cardCarouselBannerData
            heroSection
            externalHtmlContent
            faqList
            featuredCollection
            topReviews
            collectionGroup
            emailSubscription
            productInfo
            simpleProductInfo
            productListingInfo
            productReviews
            collectionCarouselData
            contactFormData
            aboutFormData
        }
    }
`;

export const PAGE_DETAILS_FRAGMENT = gql`
    fragment PageDetails on Page {
        id
        createdAt
        updatedAt
        name
        slug
        storeSite {
            id
            name
            identifier
            policyContentList {
                type
                title
                path
            }
            pages {
                id
                name
                slug
                type
                pageComponents {
                    type
                    sectionId
                    titleMode
                }
            }
            sellerChannel {
                id
                code
            }
        }
        type
        product {
            id
            name
            slug
        }
        collection {
            id
            name
            slug
        }
        webPresenceConfig {
            useBuiltInSeo
            title
            description
            sitemapIndexing
            openGraphTitleSameAsSeoTitle
            openGraphDescriptionSameAsSeoDescription
            openGraphTitle
            openGraphDescription
            metaAssetId
            h1Source
            h1Text
            h1StyleMode
            h1FontSize
            h1MobileFontSize
            h1Color
            h1Alignment
        }
        navigationMenu {
            targetType
            label
            pageSlug
            pageSection
            builtInPage
            customSlug
            websiteUrl
            targetProductId
            targetProductSlug
            targetCollectionId
            targetCollectionSlug
        }
        pageComponents {
            type
            sectionId
            titleMode
            title {
                format
                i18n
            }
            subtitle {
                format
                i18n
            }
            titleUnderline
            layoutOption
            marketingBannerData
            keyPointListData
            cardCarouselBannerData
            heroSection
            externalHtmlContent
            faqList
            featuredCollection
            topReviews
            collectionGroup
            emailSubscription
            productInfo
            simpleProductInfo
            productListingInfo
            productReviews
            collectionCarouselData
            contactFormData
            aboutFormData
        }
    }
`;
